import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayDecode'
})
export class DisplayDecodePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let key = '';
    key = atob(value);
    return key;
  }

}
